import Step4PackageCard from "../../Pages/AddOrEditPartner/PartnerSteps/Step4/Step4PackageCard";

const ListPackagesStepFour = ({
  filterTabsArray,
  currentTab,
  setCurrentTab,
  packages,
  currentTabIcon,
  Step1Info,
  selectedPackage,
  isConfirmed,
  setIsConfirmed,
  isSubmittedFlag,
  validationObject,
}) => {
  return (
    <>
      {filterTabsArray?.length > 0 ? (
        <>
          {/* Package Category Tabs */}
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-3 tw-py-2 tw-mt-3">
            {filterTabsArray?.map((tab) => (
              <div
                key={tab.id}
                className={`tw-border ${
                  tab.id == currentTab
                    ? "tw-border-[#10199ECC] tw-shadow-[0px_4px_12px_0px_#10199ECC]"
                    : ""
                } tw-relative tw-text-center tw-py-1 tw-rounded-xl tw-font-medium tw-cursor-pointer`}
                style={{
                  background: `linear-gradient(to right, ${tab.color.from}, ${tab.color.to})`,
                }}
                onClick={() => setCurrentTab(tab.id)}
              >
                <img
                  src={tab.icon}
                  alt="PackageCategory"
                  className="tw-w-10 tw-inline-block tw-mx-1"
                />
                <span>{tab.name}</span>
              </div>
            ))}
          </div>

          {/* Package List */}
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 mt-4 tw-gap-4">
            {packages?.map(
              (packageDetails, idx) =>
                packageDetails?.category_id == currentTab && (
                  <Step4PackageCard
                    key={idx}
                    packageDetails={packageDetails}
                    packageIcon={currentTabIcon}
                    clientCategory={Step1Info?.client?.client_category_id}
                    packages={packages}
                  />
                )
            )}
          </div>

          {/* Confirmation Checkbox */}
          <div className="form-check my-4 tw-flex tw-items-center">
            <input
              disabled={!selectedPackage}
              type="checkbox"
              className="form-check-input tw-h-5 tw-w-5"
              id="confirmCheckbox"
              checked={isConfirmed}
              onChange={() => setIsConfirmed(!isConfirmed)}
            />
            <label
              htmlFor="confirmCheckbox"
              className="form-check-label tw-ps-4"
            >
              I confirm that the selected package is my preferred choice, and I
              am aware that I can't change this selection later.
            </label>
          </div>

          {isSubmittedFlag && validationObject[`package_id`]?.length > 0 && (
            <div className="invalid-feedback">
              {validationObject[`package_id`].join(", ")}
            </div>
          )}
        </>
      ) : (
        <p className="tw-text-center text-black-50">
          There are no available packages for this client
        </p>
      )}
    </>
  );
};

export default ListPackagesStepFour;
